<app-template-preview (onblur)="onblur.emit()" [previewDisabled]="previewDisabled" [control]="control" [value]="value" [disabled]="disabled" (preview)="setBarcode($event)">{{
  "FORM.THREATS.BOOL.BAE"
}}</app-template-preview>
